export default __webpack_public_path__ + "static/media/gg1.3b8b4229.jpeg";